import styled from 'styled-components'

interface SingleDatePickerStyledProps {
  block?: boolean
}

export const SingleDatePickerStyled = styled.div<SingleDatePickerStyledProps>`
  position: relative;
  display: ${(props) => (props.block ? 'block' : 'inline-block')};
`
